module.exports = __webpack_public_path__ + "img/icon-open-popup-transparent.44a686d5.svg";